var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var CustomizationUtils = /** @class */ (function () {
    function CustomizationUtils() {
    }
    CustomizationUtils.applyCssCustomization = function (customization, targetUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, css, cssUrl, _b, _c, url, err_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _i = 0, _a = customization.css;
                        _d.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 9];
                        css = _a[_i];
                        cssUrl = customization.baseUrl + css.file + '.css';
                        CustomizationUtils.removeCssLink(cssUrl);
                        _b = 0, _c = css.urls;
                        _d.label = 2;
                    case 2:
                        if (!(_b < _c.length)) return [3 /*break*/, 8];
                        url = _c[_b];
                        if (!targetUrl.match(url)) return [3 /*break*/, 7];
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, CustomizationUtils.insertCssLink(cssUrl)];
                    case 4:
                        _d.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _d.sent();
                        console.error('impossible de charger le css ' + cssUrl);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        _b++;
                        return [3 /*break*/, 2];
                    case 8:
                        _i++;
                        return [3 /*break*/, 1];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    CustomizationUtils.applyJSLoadCustomization = function (customization, targetUrl) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _i, _b, js, functionName, jsUrl, _c, _d, url, err_2;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _i = 0, _b = customization.js;
                        _e.label = 1;
                    case 1:
                        if (!(_i < _b.length)) return [3 /*break*/, 11];
                        js = _b[_i];
                        functionName = ((_a = js.prefix) !== null && _a !== void 0 ? _a : '') + 'onLoad';
                        jsUrl = customization.baseUrl + js.file + '.js';
                        _c = 0, _d = js.urls;
                        _e.label = 2;
                    case 2:
                        if (!(_c < _d.length)) return [3 /*break*/, 10];
                        url = _d[_c];
                        if (!targetUrl.match(url)) return [3 /*break*/, 9];
                        if (!!window[functionName]) return [3 /*break*/, 7];
                        _e.label = 3;
                    case 3:
                        _e.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, CustomizationUtils.insertJsLink(jsUrl)];
                    case 4:
                        _e.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_2 = _e.sent();
                        console.error('impossible de charger le fichier js ' + jsUrl);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        console.log("already loaded script");
                        _e.label = 8;
                    case 8:
                        window[functionName]();
                        return [3 /*break*/, 10];
                    case 9:
                        _c++;
                        return [3 /*break*/, 2];
                    case 10:
                        _i++;
                        return [3 /*break*/, 1];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    CustomizationUtils.applyJSUnloadCustomization = function (customization, targetUrl) {
        for (var _i = 0, _a = customization.js; _i < _a.length; _i++) {
            var js = _a[_i];
            for (var _b = 0, _c = js.urls; _b < _c.length; _b++) {
                var url = _c[_b];
                // If url matches we import css
                if (targetUrl.match(url)) {
                    console.log("unload");
                    CustomizationUtils.unloadJs(js);
                }
            }
        }
    };
    CustomizationUtils.insertCssLink = function (cssUrl) {
        return new Promise(function (resolve, reject) {
            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('link');
            link.id = CustomizationUtils.stringHashCode(cssUrl) + '';
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = cssUrl;
            link.media = 'all';
            head.appendChild(link);
            link.onload = function () { resolve(); };
            link.onabort = function () { reject(); };
            link.onerror = function () { reject(); };
            link.onended = function () { reject(); };
        });
    };
    CustomizationUtils.insertJsLink = function (jsUrl) {
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.id = CustomizationUtils.stringHashCode(jsUrl) + '';
            script.setAttribute('src', jsUrl);
            document.body.appendChild(script);
            script.onload = function () { resolve(); };
            script.onabort = function () { reject(); };
            script.onerror = function () { reject(); };
            script.onended = function () { reject(); };
        });
    };
    CustomizationUtils.removeCssLink = function (url) {
        var id = CustomizationUtils.stringHashCode(url) + '';
        var element = document.getElementById(id);
        if (element) {
            element.remove();
        }
    };
    CustomizationUtils.unloadJs = function (js) {
        var _a;
        var onUnloadFunctionName = ((_a = js.prefix) !== null && _a !== void 0 ? _a : '') + 'onUnload';
        if (window[onUnloadFunctionName]) {
            window[onUnloadFunctionName]();
        }
    };
    // Hash a value
    CustomizationUtils.stringHashCode = function (str) {
        var hash = 0;
        for (var i = 0; i < str.length; ++i)
            hash = Math.imul(31, hash) + str.charCodeAt(i);
        return hash | 0;
    };
    return CustomizationUtils;
}());
export default CustomizationUtils;
//# sourceMappingURL=CustomizationUtils.js.map